import React, {useEffect, useState} from "react";
import './index.css';
// import NavigationBar from "./navBar";
import axios from "axios";
import {Link} from "react-router-dom";
import NavigationBar from "../NavigationBar";
import ProfileComponent from "./ProfileComponent";
import UserReviewList from "../UserReviewList";
import AdminEditProfile from "../AdminPage/adminEditProfile";
import AdminPage from "../AdminPage";
import DetailsList from "../Details/DetailsList";
import findRestById from "../../Services/hotel" 
const UserProfile = () => {

    //check if a session is going on
    const[user, setUser] = useState("")
    const [hotel, setHotel] = useState('')
    //using axios for easy fetching
    useEffect( () => {
        axios.get('  https://food-mafia-server.herokuapp.com/api/checkLogin').
        then(response => {
            console.log(response.data)

            // Get the complete data about the user.
            if(response.data) {
                console.log("here!!")
                setUser(response.data)
                console.log(response.data.userId)
                findRestById(response.data.userId).then(response => setHotel(response))
            }
        });
    }, []);

    const path = hotel? "/details/" + hotel.restaurant_id : "/details/";


    // const [hotel, setHotel] = useState('')
    // useEffect(() => {
    //     findRestById(user.userId).then(response => setHotel(response))
    // },[]);
    

    return (
        <>
            <NavigationBar/>
            <ProfileComponent/>
            {
                user.uType === '3'
                    &&  <AdminPage/>
            }
            {
                user.uType === '1' &&
                    <div className="container mt-1">
                        <h2>Recent Reviews</h2>
                        <UserReviewList userId={user.userId}/>
                    </div>
                
            }
            {
                user.uType === '2' &&
                    <div className="container mb-4 p-0">
                        <h2>View Your Restaurant</h2>
                        <Link to= {path} >
                        <button className="btn btn-primary">
                            View
                        </button>
                        </Link>
                    </div>
                
            }

            
            
            
        </>
    )
}

export default UserProfile;